import type { DataValue } from '../../data/sources';
import { Post } from '../../post';

export function renderPost(item: DataValue, itemIndex: number) {
  return (
    <Post key={`${item?.id}-${itemIndex}`} index={itemIndex} data={item} />
  );
}
